module.exports = __webpack_public_path__ + "img/harmonyOS_bg6.ba7e50e1.jpg";